import { DatepickerRangeProps } from "@/components/datepicker/datepicker.types.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { DatepickerRangeCore } from "@skailer-com/uikit";
import { enUS } from "date-fns/locale/en-US";
import { ru } from "date-fns/locale/ru";
import { forwardRef, Ref } from "react";
import { useTranslation } from "react-i18next";

export const DatepickerRange = forwardRef(
  (props: DatepickerRangeProps, ref: Ref<HTMLDivElement>) => {
    const { data: employee } = useEmployeeMe();
    const { renderDate } = useFormatter();
    const { t } = useTranslation();

    const locale = employee?.language === "ru" ? ru : enUS;

    return (
      <DatepickerRangeCore
        {...props}
        ref={ref}
        locale={locale}
        placeholderText={t("common:pick_a_date_range")}
        formatDate={renderDate}
      />
    );
  }
);
